




import { Component, Mixins } from "vue-property-decorator";
import {
  IHisInformationApplicable,
} from "../../../../domain/document/items";
import {
  IHisInformationGroupSource,
} from "../../../../domain/his/groupInput/HisInformationGroupSource";
import {
  InformationKinds,
} from "../../../../domain/his/behavior";
import {
  ModelEditableMixin,
} from "../../../system/mixins";
import { HisInformationApplicator } from "../helpers";
import {
  DocumentStructureEditableMixin,
  ExtraInformationUpdatableMixin,
} from "../mixins";

@Component({
})
export default class HisInformationEditor extends Mixins(
  ModelEditableMixin,
  DocumentStructureEditableMixin,
  ExtraInformationUpdatableMixin,
) {
  public async applySelectedInformation(source: IHisInformationApplicable, result: IHisInformationGroupSource): Promise<void> {
    const groupApplicator = new HisInformationApplicator(this.editingSource);
    groupApplicator.applyBySelect(source, result, this.itemSetId);
    this.executeStackedScripts();
  }

  public containsInformation(kind: InformationKinds): boolean {
    switch (kind) {
      case InformationKinds.Disease: return this.hisInformation.diseaseCollection.rows.length > 0;
      case InformationKinds.Hospitalization: return this.hisInformation.hospitalizationCollection.rows.length > 0;
      case InformationKinds.Operation: return this.hisInformation.operationCollection.rows.length > 0;
    }
    return false;
  }  
}
